import { Badge, Box, Button, Drawer, Grid, IconButton, InputAdornment, Tooltip, Typography } from '@mui/material'
import { useContextState } from '../../hooks/theme'
import { icons } from '../../utils/icons'
import BaseInput from '../dinamicForm/baseInput'
import CustomSelect from '../dinamicForm/select'
import { Props } from './props'
import { useStyles } from './styles'
import React from 'react'

type Anchor = 'top' | 'left' | 'bottom' | 'right'

const Filter = ({ title, filterTitle, textBig, firstSelect, secondSelect, refresh, add, load, filter, type = 1, sx2, right, top }: Props) => {
  const { colors } = useContextState()
  const styles = useStyles(colors, type)
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  })

  const toggleDrawer = (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (event.type === 'keydown' && ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')) {
      return
    }

    setState({ ...state, [anchor]: open })
  }

  return (
    <Box className="filterContainer-main" sx={styles.container}>
      <Typography sx={styles.title(!!textBig)}>{title ?? ''}</Typography>
      {type === 2 ? (
        <Box sx={styles.containerDetailTwo}>
          {filter && (
            <BaseInput
              sx={{ ...styles.widthInput, ...sx2 }}
              name={filter.name}
              value={filter.value}
              onChange={(e: any) => {
                filter?.onChange?.(e)
              }}
              InputProps={{
                endAdornment: <InputAdornment position="end">{icons('search')}</InputAdornment>,
              }}
            />
          )}
        </Box>
      ) : type === 4 ? (

        <Box sx={styles.containerDetail} className="filterContainer">
          <IconButton
            sx={(styles.clean, (!!filter?.value?.[filter.name]?.value) ? null : styles.hide)}
            onClick={() => {
              refresh?.onClick() 
            }}
          >
            {icons('clean')}
          </IconButton>
          {(['right'] as const).map((anchor) => (
            <React.Fragment key={anchor}>
              <Badge /* badgeContent={count} */ color="primary" sx={[styles.iconFilter, { right, top }]}>
                <Tooltip title={'Filtros'}>
                  <IconButton onClick={toggleDrawer(anchor, true)}>{icons('filter')}</IconButton>
                </Tooltip>
              </Badge>

              <Drawer
                PaperProps={{
                  sx: { width: '35%', padding: '20px', minWidth: '520px' },
                }}
                anchor={anchor}
                open={state[anchor]}
                onClose={toggleDrawer(anchor, false)}
              >
                <Grid container spacing={2}>
                  <Grid xs={12} item key={'filter-dinamicform'}>
                    <Typography
                      sx={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#707070',
                      }}
                    >
                      Filtros
                    </Typography>
                  </Grid>

                  <Grid xs={12} item>
                    {filter && (
                      <BaseInput
                        /* sx={{ ...styles.widthInput, ...filter.sx }} */
                        name={filter.name}
                        value={filter.value}
                        onChange={(e: any) => {
                          filter?.onChange?.(e)
                        }}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">{icons('search')}</InputAdornment>,
                        }}
                      />
                    )}
                  </Grid>

                  <Grid xs={12} item>
                    <Box sx={styles.actions}>
                      <Box>
                        {refresh && filter?.value?.[filter.name]?.value && (
                          <Typography variant="body1" sx={styles.cleanFilters} onClick={() => { refresh.onClick() }}>
                            Limpiar filtros
                          </Typography>
                        )}
                      </Box>

                      <Button onClick={toggleDrawer(anchor, false)} variant="contained">
                        Ocultar filtros
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Drawer>
            </React.Fragment>
          ))}

        </Box>

      ) : (
        <Box sx={styles.containerDetail} className="filterContainer">
          {firstSelect && (
            <CustomSelect
              sx={[styles.widthInput, !!firstSelect.value && styles.labelAll]}
              name={firstSelect.name}
              label={firstSelect.label}
              onChange={(e: any) => {
                firstSelect?.onChange?.(e)
              }}
              items={firstSelect.items}
              selected={firstSelect.value}
            />
          )}

          {secondSelect && (
            <CustomSelect
              sx={[styles.widthInput, !!secondSelect.value && styles.labelAll]}
              name={secondSelect.name}
              label={secondSelect.label}
              onChange={(e: any) => {
                secondSelect?.onChange?.(e)
              }}
              items={secondSelect.items}
              selected={secondSelect.value}
            />
          )}

          {filter && (
            <BaseInput
              sx={{ ...styles.widthInput, ...filter.sx }}
              name={filter.name}
              value={filter.value}
              onChange={(e: any) => {
                filter?.onChange?.(e)
              }}
              InputProps={{
                endAdornment: <InputAdornment position="end">{icons('search')}</InputAdornment>,
              }}
            />
          )}
          {refresh && (
            <IconButton
              sx={[styles.removePadding, styles.refresh]}
              onClick={() => {
                refresh.onClick()
              }}
            >
              {refresh.icon}
            </IconButton>
          )}
          {add && (
            <IconButton
              sx={[styles.removePadding, styles.add]}
              onClick={() => {
                add.onClick()
              }}
            >
              {add.icon}
            </IconButton>
          )}
          {load && (
            <IconButton
              sx={[styles.removePadding, styles.load]}
              onClick={() => {
                load.onClick()
              }}
            >
              {load.icon}
            </IconButton>
          )}
        </Box>
      )}
    </Box>
  )
}

export default Filter
